module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-note"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 4
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('TocButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("TOC" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v("Required from")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.required_from))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("Disabled")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.item.disabled))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v("Version")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v(_vm._s(_vm.item.version))]), _c('div', {
    staticClass: "field-url-detail",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'toc',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f2805be!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Toc.vue
// module id = 2622
// module chunks = 1